import roles from './roles';

import { ROUTE_PATHS } from 'common/utils/constant';
import ApproveSalaryManagement from 'extends/ApproveSalary';
import ApproveSalaryDetail from 'extends/ApproveSalary/ApproveDetail';
import ApproveSalaryHistoryDetail from 'extends/ApproveSalary/ApproveHistoryDetail';
import ApproveSalaryHistoryManagement from 'extends/ApproveSalary/ApproveSalaryHistory';
import ApprovedSalaryDetail from 'extends/ApproveSalary/ApprovedDetail';
import ApprovedSalary from 'extends/ApproveSalary/ApprovedSalary';
import BankManagement from 'extends/Bank';
import BankDetail from 'extends/Bank/detail';
import EmployeeManagement from 'extends/Employee';
import EmployeeDetail from 'extends/Employee/detail';
import EmployeeAssignManagement from 'extends/EmployeeAssign';
import EmployeeAssignImport from 'extends/EmployeeAssign/EmployeeAssignImport';
import EmployeeAssignDetail from 'extends/EmployeeAssign/detail';
import EmployeeFullTimeManagement from 'extends/EmployeeFullTime';
import EmployeeFulltimeDetail from 'extends/EmployeeFullTime/detail';
import EmployeeImport from 'extends/EmployeeImport';
import ExportSalaryManagement from 'extends/ExportSalaryManagement';
import PositionManagement from 'extends/Position';
import PositionDetail from 'extends/Position/detail';
import PreviewXLSX from 'extends/PreviewXLSX';
import ProgramManagement from 'extends/Program';
import CreateTimeKeeping from 'extends/Program/CreateTimeKeeping';
import TableSalaryDetail from 'extends/Program/TableSalaryDetail';
import ProgramDetail from 'extends/Program/detail';
import ProjectEmployeeImport from 'extends/Program/importEmployee';
import SalaryCalculationManagement from 'extends/SalaryCalculation';
import SalaryImport from 'extends/SalaryCalculation/Import';
import SalaryCalculateDetailInfo from 'extends/SalaryCalculation/SalaryCalculateDetailInfo';
import SalaryPeriodDetail from 'extends/SalaryCalculation/SalaryPeriodDetail';
import SalaryTableDetail from 'extends/SalaryCalculation/SalaryTableDetail';
import TimeSheetManagement from 'extends/TimeSheet';
import TimeKeepingDetail from 'extends/TimeSheet/TimeKeepingDetail';
import TimeSheetDetailInfo from 'extends/TimeSheet/TimeSheetDetailInfo';
import AttendanceRecordsImport from 'extends/TimeSheet/attendanceRecordsImport';
import TimeSheetDetail from 'extends/TimeSheet/detail';
import ActivityLogsManagement from 'features/ActivityLogsManagement';
import BannerManagement from 'features/BannerManagement';
import CMSTranslationsManagement from 'features/CMSTranslationsManagement';
import CategoryFaq from 'features/CategoriesFaqManagement';
import ContactManagement from 'features/ContactManagement';
import ContactProblemDetail from 'features/ContactProblemDetail';
import ContactProblemManagement from 'features/ContactProblemManagement';
import EditBanner from 'features/EditBanner';
import EditCategoryFaq from 'features/EditCategoryFaq';
import EditFaq from 'features/EditFaq';
import EditMenu from 'features/EditMenu';
import EditNews from 'features/EditNews';
import EditNewsCategory from 'features/EditNewsCategory';
import EditPageTemplate from 'features/EditPageTemplate';
import EditStaticBlocks from 'features/EditStaticBlocks';
import EmailTemplateDetail from 'features/EmailTemplateDetail';
import EmailTemplateManagement from 'features/EmailTemplateManagement';
import ErrorsManagement from 'features/ErrorsManagement';
import FETranslationsManagement from 'features/FETranslationsManagement';
import FaqManagement from 'features/FaqManagement';
import FilesManagement from 'features/FilesManagement';
import FormDetail from 'features/FormDetail';
import FormManagement from 'features/FormManagement';
import MenuManagement from 'features/MenuManagement';
import NewsCategoryManagement from 'features/NewsCategoryManagement';
import NewsManagement from 'features/NewsManagement';
import PageManagement from 'features/PageManagement';
import PageTemplate from 'features/PageTemplate';
import RedirectImport from 'features/RedirectImport';
import RedirectManagement from 'features/RedirectManagement';
import RoleDetail from 'features/RoleDetail';
import RoleManagement from 'features/RoleManagement';
import StaticBlockManagement from 'features/StaticBlockManagement';
import SubmitFormListByFormManagement from 'features/SubmitFormListByForm';
import SystemConfigsManagement from 'features/SystemConfigsManagement';
import SystemManagement from 'features/SystemManagement';
import TypeFormManagement from 'features/TypeFormManagement';
import UserDetail from 'features/UserDetail';
import UserManagement from 'features/UserManagement';

export type RolesRoute = {
  index?: string;
  create?: string;
  update?: string;
  delete?: string;
  view?: string;
  other?: string[];
};

type RouteProps = {
  id: number;
  name: string;
  path: string;
  element: React.FC<ActiveRoles>;
  roles?: RolesRoute;
};

const routes: RouteProps[] = [
  {
    id: 1,
    name: 'Page Template',
    path: ROUTE_PATHS.PAGE_TEMPLATE_MANAGEMENT,
    element: PageTemplate,
    roles: {
      index: roles.TEMPLATE_INDEX,
      update: roles.TEMPLATE_UPDATE,
    },
  },
  {
    id: 2,
    name: 'Page Management',
    path: ROUTE_PATHS.PAGE_MANAGEMENT,
    element: PageManagement,
    roles: {
      index: roles.PAGE_INDEX,
      create: roles.PAGE_STORE,
      update: roles.PAGE_UPDATE,
      delete: roles.PAGE_DESTROY,
      other: [roles.PAGE_APPROVED, roles.PAGE_COMMENT_INDEX, roles.PAGE_COMMENT_STORE],
    },
  },
  {
    id: 3,
    name: 'Page Detail',
    path: ROUTE_PATHS.PAGE_DETAIL,
    element: EditPageTemplate,
    roles: {
      index: roles.PAGE_INDEX,
      create: roles.PAGE_STORE,
      update: roles.PAGE_UPDATE,
      other: [roles.PAGE_APPROVED],
    },
  },
  {
    id: 4,
    name: 'Files Management',
    path: ROUTE_PATHS.FILE_MANAGEMENT,
    element: FilesManagement,
    roles: {
      index: roles.FOLDER_VIEWALL,
      other: [
        roles.FOLDER_STORE,
        roles.FOLDER_UPDATE,
        roles.FOLDER_DESTROY,
        roles.FOLDER_GETITEMS,
        roles.FILE_DESTROY,
        roles.FILE_UPDATE,
        roles.FILE_UPLOAD,
        roles.TRASH_EMPTY,
        roles.TRASH_INDEX,
        roles.TRASH_RESTORE,
        roles.TRASH_FORCEDELETE,
      ],
    },
  },
  {
    id: 5,
    name: 'Menu Management',
    path: ROUTE_PATHS.MENU_MANAGEMENT,
    element: MenuManagement,
    roles: {
      index: roles.MENU_INDEX,
      create: roles.MENU_STORE,
      update: roles.MENU_MANAGE,
      delete: roles.MENU_DESTROY,
    },
  },
  {
    id: 6,
    name: 'Menu Detail',
    path: ROUTE_PATHS.MENU_DETAIL,
    element: EditMenu,
    roles: {
      index: roles.MENU_INDEX,
      create: roles.MENU_STORE,
      update: roles.MENU_MANAGE,
      delete: roles.MENU_DESTROY,
    },
  },
  {
    id: 7,
    name: 'News Management',
    path: ROUTE_PATHS.NEWS_MANAGEMENT,
    element: NewsManagement,
    roles: {
      index: roles.NEWS_INDEX,
      create: roles.NEWS_STORE,
      update: roles.NEWS_UPDATE,
      delete: roles.NEWS_DESTROY,
    },
  },
  {
    id: 8,
    name: 'News Detail',
    path: ROUTE_PATHS.NEWS_DETAIL,
    element: EditNews,
    roles: {
      index: roles.NEWS_INDEX,
      update: roles.NEWS_UPDATE,
      create: roles.NEWS_STORE,
      other: [roles.NEWS_APPROVED],
    },
  },
  {
    id: 9,
    name: 'News Category Management',
    path: ROUTE_PATHS.NEWS_CATEGORY_MANAGEMENT,
    element: NewsCategoryManagement,
    roles: {
      index: roles.NEWS_CATE_INDEX,
      create: roles.NEWS_CATE_STORE,
      delete: roles.NEWS_CATE_DESTROY,
      update: roles.NEWS_CATE_UPDATE,
    },
  },
  {
    id: 10,
    name: 'News Category Detail',
    path: ROUTE_PATHS.NEWS_CATEGORY_DETAIL,
    element: EditNewsCategory,
    roles: {
      index: roles.NEWS_CATE_INDEX,
      create: roles.NEWS_CATE_STORE,
      update: roles.NEWS_CATE_UPDATE,
      other: [roles.NEWS_CATE_APPROVED],
    },
  },
  {
    id: 11,
    name: 'Banner Management',
    path: ROUTE_PATHS.BANNER_MANAGEMENT,
    element: BannerManagement,
    roles: {
      index: roles.BANNER_INDEX,
      create: roles.BANNER_STORE,
      delete: roles.BANNER_DESTROY,
      update: roles.BANNER_UPDATE,
    },
  },
  {
    id: 12,
    name: 'Banner Detail',
    path: ROUTE_PATHS.BANNER_DETAIL,
    element: EditBanner,
    roles: {
      index: roles.BANNER_INDEX,
      create: roles.BANNER_STORE,
      update: roles.BANNER_UPDATE,
    },
  },
  {
    id: 13,
    name: 'System Management',
    path: ROUTE_PATHS.SYSTEM_MANAGEMENT,
    element: SystemManagement,
    roles: {
      index: roles.SYSTEM_INDEX,
      other: [
        roles.SYSTEM_INDEX,
        roles.SYSTEM_STORE,
        roles.SEO_GENERAL_INDEX,
        roles.SEO_GENERAL_STORE,
        roles.SYSTEM_LOCALE_INDEX,
        roles.SYSTEM_LOCALE_STORE,
      ],
    },
  },
  {
    id: 14,
    name: 'System Config Management',
    path: ROUTE_PATHS.SYSTEM_CONFIG_MANAGEMENT,
    element: SystemConfigsManagement,
    roles: {
      index: roles.CONFIG_HEADER_INDEX || roles.CONFIG_FOOTER_INDEX,
      other: [roles.CONFIG_HEADER_STORE, roles.CONFIG_FOOTER_STORE],
    },
  },
  {
    id: 16,
    name: 'FE Translation Management',
    path: ROUTE_PATHS.FE_TRANSLATION_MANAGEMENT,
    element: FETranslationsManagement,
    roles: {
      index: roles.FE_TRANSLATION_INDEX,
      create: roles.FE_TRANSLATION_STORE,
      delete: roles.FE_TRANSLATION_DESTROY,
      update: roles.FE_TRANSLATION_UPDATE,
      other: [roles.CMS_TRANSLATION_EXPORT, roles.CMS_TRANSLATION_IMPORT],
    },
  },
  {
    id: 17,
    name: 'CMS Translation Management',
    path: ROUTE_PATHS.CMS_TRANSLATION_MANAGEMENT,
    element: CMSTranslationsManagement,
    roles: {
      index: roles.CMS_TRANSLATION_INDEX,
      create: roles.CMS_TRANSLATION_STORE,
      delete: roles.CMS_TRANSLATION_DESTROY,
      update: roles.CMS_TRANSLATION_UPDATE,
      other: [roles.CMS_TRANSLATION_EXPORT, roles.CMS_TRANSLATION_IMPORT],
    },
  },
  {
    id: 18,
    name: 'Redirect Management',
    path: ROUTE_PATHS.REDIRECT_MANAGEMENT,
    element: RedirectManagement,
    roles: {
      index: roles.REDIRECT_INDEX,
      create: roles.REDIRECT_STORE,
      update: roles.REDIRECT_UPDATE,
      delete: roles.REDIRECT_DESTROY,
    },
  },
  {
    id: 19,
    name: 'Redirect Import',
    path: ROUTE_PATHS.REDIRECT_IMPORT,
    element: RedirectImport,
    roles: {
      index: roles.REDIRECT_IMPORT,
    },
  },
  {
    id: 20,
    name: 'Activity Logs',
    path: ROUTE_PATHS.ACTIVITY_MANAGEMENT,
    element: ActivityLogsManagement,
    roles: {
      index: roles.ACTIVITYLOG_INDEX,
    },
  },
  {
    id: 21,
    name: 'Roles Management',
    path: ROUTE_PATHS.ROLES_MANAGEMENT,
    element: RoleManagement,
  },
  {
    id: 22,
    name: 'Roles Detail',
    path: ROUTE_PATHS.ROLES_DETAIL,
    element: RoleDetail,
  },
  {
    id: 23,
    name: 'User Management',
    path: ROUTE_PATHS.USERS_MANAGEMENT,
    element: UserManagement,
  },
  {
    id: 23,
    name: 'User Detail',
    path: ROUTE_PATHS.USERS_DETAIL,
    element: UserDetail,
  },
  {
    id: 24,
    name: 'Faq Management',
    path: ROUTE_PATHS.FAQ_MANAGEMENT,
    element: FaqManagement,
    roles: {
      index: roles.FAQ_INDEX,
      create: roles.FAQ_STORE,
      update: roles.FAQ_UPDATE,
      delete: roles.FAQ_DESTROY,
    },
  },
  {
    id: 25,
    name: 'Edit Faq',
    path: ROUTE_PATHS.FAQ_DETAIL,
    element: EditFaq,
    roles: {
      index: roles.FAQ_INDEX,
      update: roles.FAQ_UPDATE,
      create: roles.FAQ_STORE,
      other: [roles.FAQ_APPROVED],
    },
  },
  {
    id: 26,
    name: 'CategoriesFaq',
    path: ROUTE_PATHS.FAQ_CATEGORY_MANAGEMENT,
    element: CategoryFaq,
    roles: {
      index: roles.FAQ_CATEGORY_INDEX,
      create: roles.FAQ_CATEGORY_STORE,
      update: roles.FAQ_CATEGORY_UPDATE,
      delete: roles.FAQ_CATEGORY_DESTROY,
    },
  },
  {
    id: 27,
    name: 'EditCategoryFaq',
    path: ROUTE_PATHS.FAQ_CATEGORY_DETAIL,
    element: EditCategoryFaq,
    roles: {
      index: roles.FAQ_CATEGORY_INDEX,
      update: roles.FAQ_CATEGORY_UPDATE,
      create: roles.FAQ_CATEGORY_STORE,
      other: [roles.FAQ_CATEGORY_APPROVED],
    },
  },
  {
    id: 28,
    name: 'ErrorsManagement',
    path: ROUTE_PATHS.ERRORS_MANAGEMENT,
    element: ErrorsManagement,
    roles: {
      index: roles.ERROR_PAGE_400
        || roles.ERROR_PAGE_403
        || roles.ERROR_PAGE_404
        || roles.ERROR_PAGE_429
        || roles.ERROR_PAGE_500
    }
  },
  {
    id: 29,
    name: 'ContactManagement',
    path: ROUTE_PATHS.CONTACT_MANAGEMENT,
    element: ContactManagement,
    roles: {
      index: roles.CONTACT_INDEX,
      update: roles.CONTACT_UPDATE,
      delete: roles.CONTACT_DESTROY,
    },
  },
  {
    id: 30,
    name: 'ContactProblemManagement',
    path: ROUTE_PATHS.CONTACT_PROBLEM_MANAGEMENT,
    element: ContactProblemManagement,
    roles: {
      index: roles.CONTACT_PROBLEM_INDEX,
      create: roles.CONTACT_PROBLEM_STORE,
      update: roles.CONTACT_PROBLEM_UPDATE,
      delete: roles.CONTACT_PROBLEM_DESTROY,
    },
  },
  {
    id: 31,
    name: 'ContactProblemDetail',
    path: ROUTE_PATHS.CONTACT_PROBLEM_DETAIL,
    element: ContactProblemDetail,
    roles: {
      index: roles.CONTACT_PROBLEM_INDEX,
      update: roles.CONTACT_PROBLEM_UPDATE,
      create: roles.CONTACT_PROBLEM_STORE,
      other: [roles.CONTACT_PROBLEM_APPROVED],
    },
  },
  {
    id: 32,
    name: 'EmailTemplateManagement',
    path: ROUTE_PATHS.EMAIL_TEMPLATE_MANAGEMENT,
    element: EmailTemplateManagement,
    roles: {
      index: roles.EMAIL_TEMPLATE_INDEX,
      update: roles.EMAIL_TEMPLATE_UPDATE,
    },
  },
  {
    id: 33,
    name: 'EmailTemplateDetail',
    path: ROUTE_PATHS.EMAIL_TEMPLATE_DETAIL,
    element: EmailTemplateDetail,
    roles: {
      index: roles.EMAIL_TEMPLATE_INDEX,
      update: roles.EMAIL_TEMPLATE_UPDATE,
    },
  },
  {
    id: 34,
    name: 'FormManagement',
    path: ROUTE_PATHS.FORM_MANAGEMENT,
    element: FormManagement,
    roles: {
      index: roles.FORM_INDEX,
      create: roles.FORM_STORE,
      update: roles.FORM_UPDATE,
      delete: roles.FORM_DESTROY,
    },
  },
  {
    id: 35,
    name: 'FormDetail',
    path: ROUTE_PATHS.FORM_DETAIL,
    element: FormDetail,
    roles: {
      index: roles.FORM_INDEX,
      update: roles.FORM_UPDATE,
      create: roles.FORM_STORE,
    },
  },
  {
    id: 36,
    name: 'StaticBlockManagement',
    path: ROUTE_PATHS.STATIC_BLOCK_MANAGEMENT,
    element: StaticBlockManagement,
    roles: {
      index: roles.STATIC_BLOCK_INDEX,
      update: roles.STATIC_BLOCK_UPDATE,
      create: roles.STATIC_BLOCK_STORE,
      delete: roles.STATIC_BLOCK_DESTROY,
    },
  },
  {
    id: 37,
    name: 'StaticBlockDetail',
    path: ROUTE_PATHS.STATIC_BLOCK_DETAIL,
    element: EditStaticBlocks,
    roles: {
      index: roles.STATIC_BLOCK_INDEX,
      update: roles.STATIC_BLOCK_UPDATE,
      create: roles.STATIC_BLOCK_STORE,
    },
  },
  {
    id: 38,
    name: 'SubmitFormManagement',
    path: ROUTE_PATHS.SUBMIT_FORM_MANAGEMENT,
    element: TypeFormManagement,
    roles: {
      index: roles.SUBMIT_FROM,
    },
  },
  {
    id: 39,
    name: 'SubmitFormListByForm',
    path: ROUTE_PATHS.SUBMIT_FORM_LIST_BY_FORM,
    element: SubmitFormListByFormManagement,
    roles: {
      index: roles.SUBMIT_FROM_LIST_BY_FORM,
      update: roles.SUBMIT_FROM_UPDATE,
    },
  },
  {
    id: 40,
    name: 'ProgramManagement',
    path: ROUTE_PATHS.PROGRAM_MANAGEMENT,
    element: ProgramManagement,
    roles: {
      index: roles.PROJECT_INDEX,
      create: roles.PROJECT_STORE,
      update: roles.PROJECT_UPDATE,
      delete: roles.PROJECT_DESTROY,
    },
  },
  {
    id: 41,
    name: 'EmployeeManagement',
    path: ROUTE_PATHS.EMPLOYEE_MANAGEMENT,
    element: EmployeeManagement,
    roles: {
      index: roles.EMPLOYEE_INDEX,
      update: roles.EMPLOYEE_UPDATE,
      create: roles.EMPLOYEE_STORE,
      delete: roles.EMPLOYEE_DESTROY,
      other: [
        roles.PROJECT_PRINT_CONTRACT,
        roles.EXPORT_STAFF
      ]
    },
  },
  {
    id: 42,
    name: 'EmployeeDetail',
    path: ROUTE_PATHS.EMPLOYEE_DETAIL,
    element: EmployeeDetail,
    roles: {
      index: roles.EMPLOYEE_INDEX,
      update: roles.EMPLOYEE_UPDATE,
      create: roles.EMPLOYEE_STORE,
      other: [
        roles.EMPLOYEE_OCR,
        roles.BANK_INDEX,
        roles.PROVINCE_INDEX,
        roles.PROJECT_PRINT_CONTRACT
      ]
    },
  },
  {
    id: 43,
    name: 'BankManagement',
    path: ROUTE_PATHS.BANK_MANAGEMENT,
    element: BankManagement,
    roles: {
      index: roles.BANK_INDEX,
      update: roles.BANK_UPDATE,
      create: roles.BANK_STORE,
      delete: roles.BANK_DESTROY
    },
  },
  {
    id: 44,
    name: 'BankDetail',
    path: ROUTE_PATHS.BANK_DETAIL,
    element: BankDetail,
    roles: {
      index: roles.BANK_INDEX,
      update: roles.BANK_UPDATE,
    },
  },
  {
    id: 45,
    name: 'ProgramDetail',
    path: ROUTE_PATHS.PROGRAM_DETAIL,
    element: ProgramDetail,
    roles: {
      index: roles.PROJECT_INDEX,
      create: roles.PROJECT_STORE,
      update: roles.PROJECT_UPDATE,
      delete: roles.PROJECT_DESTROY,
    },
  },
  {
    id: 46,
    name: 'TimeSheetManagement',
    path: ROUTE_PATHS.TIMEKEEPING_MANAGEMENT,
    element: TimeSheetManagement,
    roles: {
      index: roles.PROJECT_INDEX,
      create: roles.PROJECT_STORE,
      update: roles.PROJECT_UPDATE,
      delete: roles.PROJECT_DESTROY,
    },
  },
  {
    id: 47,
    name: 'EmployeeImportManagement',
    path: ROUTE_PATHS.EMPLOYEE_IMPORT,
    element: EmployeeImport,
    roles: {
      index: roles.EMPLOYEE_INDEX,
      other: [roles.EMPLOYEE_IMPORT]
    },
  },
  {
    id: 48,
    name: 'TimeSheetDetail',
    path: ROUTE_PATHS.TIMESHEET_DETAIL,
    element: TimeSheetDetail,
    roles: {
      index: roles.PROJECT_INDEX,
      // create: roles.PROGRAM_STORE,
      // update: roles.PROGRAM_UPDATE,
      // delete: roles.PROGRAM_DESTROY,
      // other: [roles.PROGRAM_APPROVED],
    },
  },
  {
    id: 49,
    name: 'TimeKeepingDetail',
    path: ROUTE_PATHS.TIMEKEEPING_DETAIL,
    element: TimeKeepingDetail,
    roles: {
      index: roles.PROJECT_INDEX,
    },
  },
  {
    id: 50,
    name: 'SalaryCalculateManagement',
    path: ROUTE_PATHS.SALARY_CALCULATE_MANAGEMENT,
    element: SalaryCalculationManagement,
    roles: {
      index: roles.PROJECT_INDEX,
    },
  },
  {
    id: 51,
    name: 'TableSalaryProgramDetail',
    path: ROUTE_PATHS.SALARY_PROGRAM_DETAIL,
    element: TableSalaryDetail,
    roles: {
      index: roles.SHOW_PAYROLL_PROJECT,
      // create: roles.STORE_PAYROLL_PROJECT,
      other: [
        roles.PROJECT_APPROVED_STAFF,
        roles.PROJECT_DECLINE_STAFF,
        roles.PROJECT_UPDATE_LINK,
        roles.PROJECT_IMPORT_STAFF,
      ],
    },
  },
  {
    id: 52,
    name: 'TimeSheetDetailInfo',
    path: ROUTE_PATHS.TIMEKEEPING_DETAIL_INFO_MANAGEMENT,
    element: TimeSheetDetailInfo,
    roles: {
      index: roles.PROJECT_INDEX,
    },
  },
  {
    id: 53,
    name: 'EmployeeAssignManagement',
    path: ROUTE_PATHS.EMPLOYEE_ASSIGN_MANAGEMENT,
    element: EmployeeAssignManagement,
    roles: {
      index: roles.EMPLOYEE_ASSIGN_INDEX,
      update: roles.EMPLOYEE_ASSIGN_UPDATE,
      create: roles.EMPLOYEE_ASSIGN_STORE,
      delete: roles.EMPLOYEE_ASSIGN_DESTROY,
      other: [roles.EMPLOYEE_ASSIGN_IMPORT, roles.EXPORT_STAFF_ASSIGN]
    },
  },
  {
    id: 54,
    name: 'EmployeeAssignDetail',
    path: ROUTE_PATHS.EMPLOYEE_ASSIGN_DETAIL,
    element: EmployeeAssignDetail,
    roles: {
      index: roles.EMPLOYEE_ASSIGN_INDEX,
      update: roles.EMPLOYEE_ASSIGN_UPDATE,
      create: roles.EMPLOYEE_ASSIGN_STORE,
      other: [roles.EMPLOYEE_ASSIGN_OCR]
    },
  },
  {
    id: 56,
    name: 'SalaryCalculateDetail',
    path: ROUTE_PATHS.SALARY_CALCULATE_DETAIL,
    element: SalaryCalculateDetailInfo,
    roles: {
      index: roles.PROJECT_INDEX
    },
  },
  {
    id: 57,
    name: 'SalaryPeriodDetail',
    path: ROUTE_PATHS.SALARY_CALCULATE_PERIOD_DETAIL,
    element: SalaryPeriodDetail,
    roles: {
      index: roles.PROJECT_INDEX
    },
  },
  {
    id: 58,
    name: 'ApproveSalaryManagement',
    path: ROUTE_PATHS.APPROVE_SALARY_MANAGEMENT,
    element: ApproveSalaryManagement,
    roles: {
      index: roles.APPROVE_DEPARTMENT_INDEX,
    },
  },
  {
    id: 59,
    name: 'ApproveSalaryDetail',
    path: ROUTE_PATHS.APPROVE_SALARY_DETAIL,
    element: ApproveSalaryDetail,
    roles: {
      index: roles.APPROVE_DEPARTMENT_SHOW,
    },
  },
  {
    id: 60,
    name: 'SalaryCalculateTableDetail',
    path: ROUTE_PATHS.SALARY_CALCULATE_TABLE_DETAIL,
    element: SalaryTableDetail,
    roles: {
      index: roles.PROJECT_INDEX,
    },
  },
  {
    id: 61,
    name: 'ProjectEmployeeImportManagement',
    path: ROUTE_PATHS.PROJECT_EMPLOYEE_IMPORT,
    element: ProjectEmployeeImport,
    roles: {
      index: roles.PROJECT_INDEX,
      other: [roles.EMPLOYEE_IMPORT]
    },
  },
  {
    id: 62,
    name: 'ApproveHistoryManagement',
    path: ROUTE_PATHS.APPROVE_HISTORY,
    element: ApproveSalaryHistoryManagement,
    roles: {
      index: roles.PAYROLL_PERIOD_APPROVE_LOG,
      other: [roles.PAYROLL_PERIOD_APPROVE_LOG]
    },
  },
  {
    id: 63,
    name: 'AttendanceRecordsImport',
    path: ROUTE_PATHS.ATTENDANCE_RECORDS_IMPORT,
    element: AttendanceRecordsImport,
    roles: {
      index: roles.ATTENDANCE_RECORD_IMPORT,
      other: [
        roles.ATTENDANCE_RECORD_IMPORT,
        roles.ATTENDANCE_RECORD_EXPORT_INDEX
      ]
    },
  },
  {
    id: 64,
    name: 'EmployeeAssignImport',
    path: ROUTE_PATHS.EMPLOYEE_ASSIGN_IMPORT,
    element: EmployeeAssignImport,
    roles: {
      index: roles.EMPLOYEE_ASSIGN_INDEX,
      other: [roles.EMPLOYEE_ASSIGN_IMPORT]
    },
  },
  {
    id: 65,
    name: 'ExportSalarySummary',
    path: ROUTE_PATHS.EXPORT_SALARY_SUMMARY,
    element: ExportSalaryManagement,
    roles: {
      index: roles.EXPORT_INDEX
    },
  },
  {
    id: 66,
    name: 'SalaryImport',
    path: ROUTE_PATHS.SALARY_CALCULATE_IMPORT,
    element: SalaryImport,
    roles: {
      index: roles.ATTENDANCE_RECORD_INDEX,
      other: [roles.ATTENDANCE_RECORD_IMPORT,
      roles.ATTENDANCE_RECORD_EXPORT_INDEX]
    }
  },
  {
    id: 67,
    name: 'ApproveSalaryHistoryDetail',
    path: ROUTE_PATHS.APPROVE_HISTORY_DETAIL,
    element: ApproveSalaryHistoryDetail,
    roles: {
      index: roles.PAYROLL_PERIOD_APPROVE_LOG,
    },
  },
  {
    id: 67,
    name: 'EmployeeFulltimeManagement',
    path: ROUTE_PATHS.EMPLOYEE_FULLTIME_MANAGEMENT,
    element: EmployeeFullTimeManagement,
    roles: {
      index: roles.EMPLOYEE_FULLTIME_INDEX,
      create: roles.EMPLOYEE_FULLTIME_STORE,
      delete: roles.EMPLOYEE_FULLTIME_DESTROY,
      update: roles.EMPLOYEE_FULLTIME_UPDATE
    },
  },
  {
    id: 68,
    name: 'EmployeeFulltimeDetail',
    path: ROUTE_PATHS.EMPLOYEE_FULLTIME_DETAIL,
    element: EmployeeFulltimeDetail,
    roles: {
      index: roles.EMPLOYEE_FULLTIME_INDEX,
      create: roles.EMPLOYEE_FULLTIME_STORE,
      delete: roles.EMPLOYEE_FULLTIME_DESTROY,
      update: roles.EMPLOYEE_FULLTIME_UPDATE
    },
  },
  {
    id: 69,
    name: 'PositionManagement',
    path: ROUTE_PATHS.POSITION_MANAGEMENT,
    element: PositionManagement,
    roles: {
      index: roles.POSITION_INDEX,
      create: roles.POSITION_STORE,
      delete: roles.POSITION_DESTROY,
      update: roles.POSITION_UPDATE
    },
  },
  {
    id: 70,
    name: 'PositionDetail',
    path: ROUTE_PATHS.POSITION_DETAIL,
    element: PositionDetail,
    roles: {
      index: roles.POSITION_INDEX,
      create: roles.POSITION_STORE,
      delete: roles.POSITION_DESTROY,
      update: roles.POSITION_UPDATE
    },
  },
  {
    id: 71,
    name: 'CreateTimeKeeping',
    path: ROUTE_PATHS.PROJECT_TIMESHEET_DETAIL,
    element: CreateTimeKeeping,
    roles: {
      index: roles.PROJECT_INDEX,
      // create: roles.PROGRAM_STORE,
      // update: roles.PROGRAM_UPDATE,
      // delete: roles.PROGRAM_DESTROY,
      // other: [roles.PROGRAM_APPROVED],
    },
  },
  {
    id: 72,
    name: 'ApprovedSalaryManagement',
    path: ROUTE_PATHS.APPROVED_SALARY_MANAGEMENT,
    element: ApprovedSalary,
    roles: {
      index: roles.PAYROLL_PERIOD_APPROVED,
    },
  },
  {
    id: 73,
    name: 'ApprovedSalaryDetail',
    path: ROUTE_PATHS.APPROVED_SALARY_DETAIL,
    element: ApprovedSalaryDetail,
    roles: {
      index: roles.APPROVE_SALARY_APPROVE_SHOW,
    },
  },
  {
    id: 74,
    name: 'PreviewFileExport',
    path: ROUTE_PATHS.PREVIEW_FILE,
    element: PreviewXLSX,
    roles: {
      index: roles.EXPORT_INDEX,
    },
  },
];

export default routes;
